<template>
  <div>
    <Header />
    <b-container>
      <h1 class="mt-4">Nuestras canchas</h1>
      <div class="clearfix">
        <b-img
          width="140"
          class="ml-3 float-right"
          src="../assets/courts.jpg"
          rounded="circle"
          fluid
          alt="Canchas"
        />
        <p class="lead">
          Contamos con 3 canchas de <strong class="font-weight-bold">basketball y volleyball</strong>.
          <br>Reserva tu cancha y disfruta de nuestras instalaciones con tus amigos.
        </p>
        <h4>Precios</h4>
        <b-row>
          <b-col class="d-none d-md-block" md="3" lg="4" />
          <b-col cols="12" md="6" lg="4">
            <b-list-group>
              <b-list-group-item>
                <div class="d-flex justify-content-between">
                  <strong>Lunes a Viernes</strong>
                  <strong>$35/hora</strong>
                </div>
              </b-list-group-item>
              <b-list-group-item>
                <div class="d-flex justify-content-between">
                  <strong>Sábados y Domingos</strong>
                  <strong>$25/hora</strong>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-col>
          <b-col class="d-none d-md-block" md="3" lg="4" />
        </b-row>
      </div>
      <hr/>
      <Jumbo
        label="¡Reserva Ya!"
      />
    </b-container>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/home/Header.vue'
import Footer from '@/components/home/Footer.vue'
import Jumbo from '@/components/home/Jumbo.vue'
export default {
  components: {
    Header,
    Jumbo,
    Footer
  }
}
</script>\
